import {Component, OnInit, PLATFORM_ID, Inject, Input} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {Contact} from "../page/contact/contact";
import {EventsService} from "../../bo/events/events.service";
import {FonctionUtiles} from "../fonctionsUtiles";

@Component({
  selector: 'app-contact-form-modal',
  templateUrl: './contact-form-modal.component.html',
  styleUrls: ['./contact-form-modal.component.css']
})
export class ContactFormModalComponent implements OnInit {

  contact:Contact = new Contact();
  errors:any = new Array();
  pendingRequest:boolean = false;
  done:boolean = false;
  @Input() orgaMail:any;


  constructor(@Inject(PLATFORM_ID) private platformId: Object,private eventservice :EventsService,private fonctionUtils:FonctionUtiles) { }

  ngOnInit() {


  }

  okk()
  {
    this.done = false;
  }

  showModal(){
    if (isPlatformBrowser(this.platformId)) {
      try {
        let $ = window['jQuery'];
        $('#contact').modal('show');
      } catch (e) {
        console.log("not in browser");
      }
    }
  }
  onSubmit(validity) {

    this.contact.OrgaMail = this.orgaMail;
    this.contact.lang = this.fonctionUtils.retrieve('curentLang');

    if(this.validation(validity)) {
      this.send();
    }

  }

  validation(validity): boolean {
    // re init errors
    this.errors = new Array();

    if(this.contact.destinataire=="" || this.contact.email=="" || this.contact.last_name=="" ||
      this.contact.first_name=="")
    {
      this.errors.push('formulaire incomplet')
    }

    if(this.errors.length) {
      this.displayErrors();
      return false;
    }
    // no errors
    return true;
  }



  send() {
    this.pendingRequest=true;
    this.eventservice.contactSend(this.contact)
      .then(res => {
        this.pendingRequest=false;
        this.done=true

      })
      .catch(error => {
        this.pendingRequest=false;
        this.done=false;
        this.pendingRequest=false;
        this.errors.push('une erreur s\'est produite');
        this.displayErrors();

        console.log(error);
      });
  }

  displayErrors() {
    window.scrollTo(0,0);
  }



  ok(){
    if (isPlatformBrowser(this.platformId)) {
      try {
        let $ = window['jQuery'];
        $('#contact').modal('hide');

      } catch (e) {
        console.log("not in browser");
      }
    }
  }

  closeModal(){
    if (isPlatformBrowser(this.platformId)) {
      try {
        let $ = window['jQuery'];
        $('#contact').modal('hide');
      } catch (e) {
        console.log("not in browser");
      }
    }
  }

}
